import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import * as Yup from "yup";
import axios from "axios";

export default function FormRegistroCalificaciones(props) {
  const { cursoCali, onRefetch } = props;
  const { auth } = useAuth();
  const numeroUnidades = cursoCali.curso_data.materia_data.numero_unidades;

  const updateAlumno = async (alumnoId, data) => {
    try {
      await updateCursoAlumnoApi(alumnoId, data, auth.token);
      return alumnoId; // Devolver el ID del alumno actualizado
    } catch (error) {
      throw error;
    }
  };

  async function updateCursoAlumnoApi(id, data) {
    try {
      const url = `${BASE_API}/api/calificacion_curso/${id}/`;
      const headers = {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      toast.success("Calificaciones registradas exitosamente");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(cursoCali, numeroUnidades),
    validationSchema: Yup.object(updateSchema(numeroUnidades)),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        await updateAlumno(cursoCali.id, formValue);
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        {[...Array(numeroUnidades)].map((_, index) => (
          <div key={index}>
            <label>
              Calificación Parcial {index + 1}
            </label>
            <Form.Input
              name={`calificacion_parcial_${index + 1}`}
              placeholder="Calificación"
              value={formik.values[`calificacion_parcial_${index + 1}`]}
              onChange={formik.handleChange}
              error={formik.errors[`calificacion_parcial_${index + 1}`]}
            />
          </div>
        ))}
        <div>
          <label>
            Calificación Final<span className="astedisco">*</span>
          </label>
          <Form.Input
            name="calificacion_final"
            placeholder="Calificación"
            value={formik.values.calificacion_final}
            onChange={formik.handleChange}
            error={formik.errors.calificacion_final}
          />
        </div>
        <div>
          <label>
            Porcentaje de Asistencia<span className="astedisco">*</span>
          </label>
          <Form.Input
            name="porcentaje_asistencia"
            placeholder="Porcentaje de Asistencia"
            value={formik.values.porcentaje_asistencia}
            onChange={formik.handleChange}
            error={formik.errors.porcentaje_asistencia}
          />
        </div>
        <Button
          type="submit"
          content={cursoCali ? "Guardar" : "Crear"}
          className="botonEnviar"
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosCaliCurso, numeroUnidades) {
  const values = {};
  for (let i = 1; i <= numeroUnidades; i++) {
    values[`calificacion_parcial_${i}`] =
      datosCaliCurso[`calificacion_parcial_${i}`] || "";
  }
  values.calificacion_final = datosCaliCurso.calificacion_final || "";
  values.porcentaje_asistencia = datosCaliCurso.porcentaje_asistencia || "";
  return values;
}

function updateSchema(numeroUnidades) {
  const schema = {};
  schema.calificacion_final = Yup.number()
    .required("Este campo es obligatorio")
    .min(0, "El valor debe ser al menos 0")
    .max(10, "El valor no puede ser mayor que 10");
  schema.porcentaje_asistencia = Yup.number()
    .required("Este campo es obligatorio")
    .min(0, "El valor debe ser al menos 0")
    .max(100, "El valor no puede ser mayor que 100");
  return schema;
}
